import {
  Button,
  Flex,
  Icon,
  IconButton,
  MenuButton,
  Select,
} from '@chakra-ui/react';
import firebase from 'firebase';
import moment from 'moment';
import { Moment } from 'moment-recur-ts';
import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'react-feather';
import { useCollectionDataOnce } from 'react-firebase-hooks/firestore';
import { useHistory } from 'react-router-dom';
import { PageContainer } from '../../components/container/PageContainer';
import { Datepicker } from '../../components/styled-chakra/Datepicker';
import { Menu } from '../../components/styled-chakra/Menu';
import { useCourseOfTheDate } from '../../hooks/useCourses';
import { useCurrentUser } from '../../hooks/useCurrentUser';
import { CourseCategory } from '../../types/types';
import { GuardedPage } from '../guard-pages/GuardedPage';
import { LoadingPage } from '../util-pages/LoadingPage';
import { WeekdayItem } from './WeekdayItem';

export const UpcomingCoursesPage = () => {
  const currentUser = useCurrentUser();
  const history = useHistory();
  const [category, setCategory] = useState('');
  const [date, setDate] = useState(moment().format('YYYY-MM-DD'));
  const { courses, config } = useCourseOfTheDate(moment(date), category);

  const [categories] = useCollectionDataOnce<CourseCategory>(
    firebase.firestore().collection('courseCategories'),
    { idField: 'uid' }
  );
  const increaseTab = () => {
    setDate(moment(date).add(1, 'days').format('YYYY-MM-DD'));
  };

  const decreaseTab = () => {
    setDate(moment(date).subtract(1, 'days').format('YYYY-MM-DD'));
  };

  if (!currentUser || !config || !categories) return <LoadingPage isHeader />;

  const minDate = (currentDate: Moment) =>
    currentDate.isSameOrAfter(moment().subtract(1, 'days'));

  return (
    <GuardedPage>
      <PageContainer isHeader>
        <Flex direction={['column', 'column', 'row']} justify="flex-end">
          {categories.length > 0 && (
            <Flex flex={1} mb={4} mr={[0, 0, 2]}>
              <Select
                focusBorderColor="brand.500"
                borderRadius="xl"
                onChange={(e) => setCategory(e.target.value)}
                value={category}
                style={{ textTransform: 'uppercase' }}
              >
                <option value="">Alle Kurse</option>
                {categories.map((trail) => (
                  <option key={trail.uid} value={trail.uid}>
                    {trail.title}
                  </option>
                ))}
              </Select>
            </Flex>
          )}
          <Flex mb={6}>
            <IconButton
              borderRadius="xl"
              aria-label="e"
              isDisabled={moment(date) <= moment()}
              onClick={decreaseTab}
              icon={<Icon as={ChevronLeft} />}
              mr={2}
            />
            <Menu
              triggerComponent={
                <MenuButton
                  as={Button}
                  textAlign="center"
                  borderRadius="xl"
                  w={['full', 'full', 'auto']}
                >
                  {moment(date).format('L')}
                </MenuButton>
              }
            >
              <Datepicker
                p={2}
                isValidDate={minDate}
                value={moment(date)}
                input={false}
                onChange={(v) => {
                  setDate(moment(v).format('YYYY-MM-DD'));
                }}
                locale="de"
                timeFormat={false}
              />
              <Button
                borderRadius={0}
                size="sm"
                isFullWidth={true}
                onClick={() => setDate(moment().format('YYYY-MM-DD'))}
              >
                Heute
              </Button>
            </Menu>
            <IconButton
              ml={2}
              borderRadius="xl"
              aria-label="e"
              onClick={increaseTab}
              icon={<Icon as={ChevronRight} />}
            />
          </Flex>
        </Flex>
        {courses && (
          <WeekdayItem
            weekday={{
              date: moment(date),
              courses,
              isToday: moment(date).isSame(moment(), 'date'),
            }}
            currentUser={currentUser}
            history={history}
            config={config}
            categories={categories}
          />
        )}
      </PageContainer>
    </GuardedPage>
  );
};
